/**
 * Copyright IBM Corp. 2022, 2026
 */

import { MDSButton } from '@hashicorp/mds-react/components'
import s from './style.module.css'

const AUDIO_PROVIDER_URL_MAP = {
	soundcloudUrl: 'Soundcloud',
	applePodcastsUrl: 'Apple Podcasts',
	googlePodcastsUrl: 'Google Podcasts',
	spotifyUrl: 'Spotify',
}

export default function AudioBlock({ record }) {
	const {
		id,
		__typename,
		subscribeCtaText,
		soundcloudEpisodeId,
		...audioProviderLinks // Extract audio provider links
	} = record
	return (
		<section className={s.audioBlock}>
			{subscribeCtaText ? <h5>{subscribeCtaText}</h5> : null}
			<div className={s.embed}>
				<SoundcloudEmbed episode={soundcloudEpisodeId} />
			</div>
			<div className={s.providerLinks}>
				{Object.keys(audioProviderLinks)
					.filter((provider) => !!record[provider]) // We only render buttons for those providers which have a URL value provided on the record
					.map((provider) => (
						<MDSButton
							key={provider}
							title={AUDIO_PROVIDER_URL_MAP[provider]}
							external
							url={audioProviderLinks[provider]}
						/>
					))}
			</div>
		</section>
	)
}

function SoundcloudEmbed({ episode }) {
	if (!episode) return null
	return (
		<iframe
			title={episode}
			width="100%"
			height="166"
			scrolling="no"
			frameBorder="no"
			allow="autoplay"
			src={`https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/${episode}&color=%23ff5500&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=true`}
		/>
	)
}
